<template>
    <div :class="{ scrolled: pageScrolled }" class="the-header">
        <div class="container two-sided">
            <div class="left">
                <div class="logo">
                    <router-link :to="{ name: 'home' }">
                        <template v-if="!isEventDate">
                            <IconLogo class="icon" />
                        </template>
                        <template v-else-if="getCurrentEvent.id === 'NEW_YEAR'">
                            <IconNewYearLogo class="icon" />
                        </template>
                    </router-link>
                </div>

                <div class="search-content">
                    <slot />
                </div>
            </div>

            <div class="right action-group menu-group">
                <button v-if="canEditCard || canRequestEditCard" class="only-icon accent menu-item add-product"
                        @click="createNew">
                    <IconAdd class="icon" />
                </button>
                <TooltipOld v-if="canEditCard || canRequestEditCard" bind-to=".add-product" class="hint"
                            trigger-on="hover">
                    Добавить продукт
                </TooltipOld>

                <router-link active-class="accent-border"
                             class="menu-item item-home link"
                             exact-path
                             to="/">Продукты
                </router-link>
                <router-link :to="{ name: 'about-site' }"
                             active-class="accent-border"
                             class="menu-item item-about-site link">О портале
                </router-link>
                <router-link v-if="hasAnyDictRight"
                             :to="{ name: 'admin' }"
                             active-class="accent-border"
                             class="menu-item item-home link">Администрирование
                </router-link>

                <template v-if="admin">
                    <button :class="{ active: $refs.analyticsMenu && $refs.analyticsMenu.triggered }"
                            class="only-icon menu-item action item-analytics"
                            @click.stop>
                        <IconAnalytics class="icon" />
                    </button>
                    <TooltipOld bind-to=".item-analytics" class="hint" trigger-on="hover">Аналитика</TooltipOld>
                    <TooltipOld ref="analyticsMenu"
                                bind-to=".item-analytics"
                                class="inform small analytics-menu"
                                trigger-on="click">
                        <a class="item"
                           href="https://metrika.yandex.ru/overview?id=96366197" target="_blank">
                            Яндекс Метрика
                        </a>
                        <button class="item" @click="openAnalytics">
                            Отчёт по порталу
                        </button>
                    </TooltipOld>
                </template>

                <button class="only-icon menu-item action item-feedback" @click="openFeedback">
                    <IconFeedback class="icon" />
                </button>
                <TooltipOld bind-to=".item-feedback" class="hint" trigger-on="hover">Обратная связь</TooltipOld>
                <button :class="{
                                 count: unreadCounter
                                }"
                        class="only-icon menu-item action item-notify"
                        @click="openNews">
                    <IconNotify class="icon" />
                </button>
                <TooltipOld bind-to=".item-notify" class="hint" trigger-on="hover">Уведомления</TooltipOld>
                <button class="only-icon menu-item action item-profile" @click="openProfile">
                    <IconUser class="icon" />
                </button>
                <TooltipOld bind-to=".item-profile" class="hint" trigger-on="hover">Профиль</TooltipOld>
            </div>
        </div>

        <CreateProduct ref="createProduct" />
        <CreateProductRequest ref="createProductRequest" />
        <Profile ref="profile" />
        <News ref="newsModal" @close="closeNews" />
        <Feedback ref="feedback" />
        <Analytics ref="analytics" />
    </div>
</template>

<script>
import Analytics from '@/common/page_comp/Analytics/Analytics.vue';
import CreateProduct from '@/common/page_comp/CreateCard/product/CreateProduct.vue';
import CreateProductRequest from '@/common/page_comp/CreateCard/productRequest/CreateProductRequest.vue';
import Feedback from '@/common/page_comp/Feedback/Feedback.vue';
import News from '@/common/page_comp/News/desktop/News.vue';
import Profile from '@/common/page_comp/Profile/Profile.vue';

import { EDIT_CARD, REQUEST_EDIT_CARD } from '@/common/rights.js';
import { ADMIN } from '@/common/role.ids.js';
import { hasAnyDictRight, hasRights, hasRoles } from '@/common/session.js';
import { showNotice } from '@dsee/components/popups/message.js';

import IconLogo from '../icons/logo.svg?component';
import IconNewYearLogo from '../icons/new_year_logo.svg?component';
import IconAdd from '../icons/add.svg?component';
import IconFeedback from '../icons/feedback.svg?component';
import IconNotify from '../icons/notify.svg?component';
import IconUser from '../icons/user.svg?component';
import IconAnalytics from '../icons/analytics.svg?component';

import NewsDefaultMixins from '@/layouts/common/news.default.mixins.js';
import EventsMixin from '@/common/events/common/mixins/events.mixin.js';


export default {
    name: 'TheHeader',
    mixins: [ NewsDefaultMixins, EventsMixin ],
    components: {
        Analytics,
        Feedback,
        News,
        Profile,
        CreateProduct,
        CreateProductRequest,
        IconLogo,
        IconAdd,
        IconFeedback,
        IconNotify,
        IconUser,
        IconAnalytics,
        IconNewYearLogo,
    },
    data() {
        return {
            pageScrolled: false,
        };
    },
    computed: {
        canEditCard() {
            return hasRights([ EDIT_CARD ]);
        },
        canRequestEditCard() {
            return hasRights([ REQUEST_EDIT_CARD ]);
        },
        hasAnyDictRight() {
            return hasAnyDictRight();
        },
        admin() {
            return hasRoles([ ADMIN ]);
        },
    },
    mounted() {
        document.addEventListener('scroll', this.onScroll);
    },
    methods: {
        onScroll() {
            this.pageScrolled = window.scrollY > 0;
        },
        async createNewProduct() {
            const resp = await this.$refs.createProduct.open();

            if (!resp)
                return;

            this.$router.push({
                name: 'product',
                params: {
                    id: resp,
                },
            });
        },
        requestNewProduct() {
            this.$refs.createProductRequest.open();
        },
        async createNew() {
            if (this.canEditCard) {
                this.createNewProduct();
            } else if (this.canRequestEditCard) {
                this.requestNewProduct();
            }
        },
        openProfile() {
            if (this.newsModalOpen)
                this.closeNews();

            this.$refs.profile.open();
        },
        openFeedback(data) {
            if (this.newsModalOpen)
                this.closeNews();

            this.$refs.feedback.open(data);
        },
        openAnalytics() {
            this.$refs.analytics.open();
        },
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.onScroll);
    },
};
</script>

<style lang="scss">
.particles-container {
    @import "~@/common/events/common/mixins/particles.drop.style";
}
</style>

<style lang="scss" scoped>
.the-header {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 32px;
    transition: var(--transition-function);

    &.scrolled {
        box-shadow: 0px 12px 20px 0px rgba(28, 41, 61, 0.06), 0px 0px 20px 0px rgba(28, 41, 61, 0.05);
    }

    .container {
        @media (min-width: 1920px) {
            margin: 0 auto;
            max-width: 1816px;
        }
    }

    .left {
        display: flex;

        .search-content {
            width: 100%;
            margin-left: 32px;
            margin-right: 18px;
        }
    }

    .right {
        flex: 1;
    }

    .menu-group {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;

        .add-product {
            margin-right: 12px;
        }

        .menu-item.link {
            padding: var(--button-medium-padding);
            border-radius: var(--input-border-radius);

            &:not(:first-child) {
                margin-right: 4px;
                margin-left: 0;
            }
        }

        .menu-item.action {
            background: rgba(249, 249, 251, 1);
            border: 1px solid transparent;
            position: relative;

            &:hover {
                background: rgba(255, 79, 18, 0.1);
                box-shadow: none;
            }

            &:active,
            &.active {
                background: rgba(255, 255, 255, 1);
                border: 1px solid var(--theme-accent-color);
                color: var(--theme-accent-color);
                box-shadow: none;
            }


            &.item-notify {
                &.count:after {
                    content: '';
                    position: absolute;
                    top: 4px;
                    right: 4px;
                    border-radius: 50%;
                    background-color: #FF2626;
                    width: 8px;
                    height: 8px;
                }
            }
        }
    }
}

.analytics-menu {
    .item {
        color: var(--text-color);
        font-weight: 400;
        padding: 8px 12px;
        display: block;
        border: none;

        &:hover,
        &:active {
            background: var(--option-item-hover-background);
            border-radius: var(--table-border-radius);
        }
    }
}
</style>
